/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: queueProfilesActions.ts
 🗓️ Created: 2026-05-02
 🧩 Description:
    Implementation of the Queue Profiles module.
────────────────────────────────────────────────────────────────*/

import type { NavigateFunction } from 'react-router-dom';
import { deleteQueueProfile } from '../queueProfiles/api';

/**
 * Shared helpers for Queue Profiles module actions (used in Grid + Form views).
 */

/**
 * Build the URL used to duplicate a Queue Profile in the form.
 * Pattern: /settings/pbx/queue-profiles/new?duplicate={id}
 */
export const getQueueProfileDuplicateUrl = (id: string | number): string =>
  `/settings/pbx/queue-profiles/new?duplicate=${id}`;

/**
 * Navigate to the form in duplicate mode for the given Queue Profile id.
 */
export const navigateToQueueProfileDuplicate = (
  navigate: NavigateFunction,
  id: string | number,
): void => {
  navigate(getQueueProfileDuplicateUrl(id));
};

/**
 * Low-level API helper to delete a Queue Profile by id.
 * UI components are responsible for showing notifications and handling navigation/refresh.
 * @deprecated Use deleteQueueProfile from '../queueProfiles/api' directly
 */
export const deleteQueueProfileById = async (id: string | number): Promise<void> => {
  await deleteQueueProfile(id);
};

